// utils/detectSuspicious.ts
export const isSuspiciousEnvironment = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const suspiciousPatterns = [
    "frida",
    "rooted",
    "genymotion",
    "emulator",
    "sdk_google",
    "sdk",
    "vbox",
    "test-keys",
  ];

  const isHeadless = navigator.webdriver || false;
  const hasSuspiciousUA = suspiciousPatterns.some((p) => userAgent.includes(p));

  // Bypass if it's our own app (checking for 'mpleapp' in UA)
  if (userAgent.includes("mpleapp")) {
    return false;
  }

  // Bypass if it's our own app
  if (typeof window !== "undefined" && (window as any).__APP_META__) {
    return false;
  }

  return isHeadless || hasSuspiciousUA;
};
